var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ghost"}},[_c('div',{staticClass:"ghost"},[_c('div',{staticClass:"ghost__waves"},[_c('div',{staticClass:"ghost__wave"}),_c('div',{staticClass:"ghost__wave"})]),_c('div',{staticClass:"ghost__eyes"},[_c('div',{staticClass:"ghost__eyes_eye"}),_c('div',{staticClass:"ghost__eyes_eye"})]),_c('div',{staticClass:"ghost__mouth"})])])
}]

export { render, staticRenderFns }